import { render, staticRenderFns } from "./paymentIAAConfig.vue?vue&type=template&id=be3528f0&scoped=true&"
import script from "./paymentIAAConfig.vue?vue&type=script&lang=js&"
export * from "./paymentIAAConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be3528f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\sdk_manage_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be3528f0')) {
      api.createRecord('be3528f0', component.options)
    } else {
      api.reload('be3528f0', component.options)
    }
    module.hot.accept("./paymentIAAConfig.vue?vue&type=template&id=be3528f0&scoped=true&", function () {
      api.rerender('be3528f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/payment/paymentIAAConfig.vue"
export default component.exports